"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wsMachine = exports.update = exports.calcBackoff = exports.Effects = exports.Actions = exports.States = void 0;
var unionize_1 = __importStar(require("unionize"));
var atom_1 = require("@libre/atom");
exports.States = unionize_1.default({
    INITIAL: unionize_1.ofType(),
    CONNECTING: unionize_1.ofType(),
    OPEN: unionize_1.ofType(),
    CLOSED: unionize_1.ofType(),
    RECONNECTING: unionize_1.ofType(),
});
exports.Actions = unionize_1.default({
    CONNECT: {},
    OPEN: {},
    HEARTBEAT: {},
    PING_TIMEOUT: {},
    PONG_TIMEOUT: {},
    CLOSE: {},
    RECONNECT: {},
});
exports.Effects = unionize_1.default({
    CONNECT_WS: unionize_1.ofType(),
    SCHEDULE_TIMEOUT: unionize_1.ofType(),
    SEND_PING: unionize_1.ofType(),
    CLEAR_TIMEOUT: unionize_1.ofType(),
    TRIGGER_ACTION: unionize_1.ofType(),
});
var calcBackoff = function (attempt, randSeed, maxVal) {
    if (maxVal === void 0) { maxVal = 30000; }
    if (attempt === 0) {
        return 0;
    }
    return Math.min(maxVal, Math.pow(attempt, 2) * 1000) + 2000 * randSeed;
};
exports.calcBackoff = calcBackoff;
var connect = function (state) { return [
    exports.States.CONNECTING(state),
    [
        exports.Effects.CLEAR_TIMEOUT({ key: "connect" }),
        exports.Effects.CONNECT_WS({
            url: state.url,
            onOpen: exports.Actions.OPEN(),
            onClose: exports.Actions.CLOSE(),
            onPongMessage: exports.Actions.HEARTBEAT(),
        }),
    ],
]; };
var clearTimeoutEffect = function (key) { return exports.Effects.CLEAR_TIMEOUT({ key: key }); };
var clearAllTimeoutsEffects = [
    clearTimeoutEffect("connect"),
    clearTimeoutEffect("ping"),
    clearTimeoutEffect("pong"),
];
var scheduleConnect = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "connect",
        timeoutMillis: state.backoffFn(state.reconnectAttempt + 1, state.randSeed),
        onTimeout: exports.Actions.CONNECT(),
    });
};
var schedulePing = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "ping",
        timeoutMillis: state.pingTimeoutMillis,
        onTimeout: exports.Actions.PING_TIMEOUT(),
    });
};
var waitForPong = function (state) {
    return exports.Effects.SCHEDULE_TIMEOUT({
        key: "pong",
        timeoutMillis: state.pongTimeoutMillis,
        onTimeout: exports.Actions.PONG_TIMEOUT(),
    });
};
var update = function (action, state) {
    return exports.States.match(state, {
        INITIAL: function () {
            return exports.Actions.match(action, {
                CONNECT: function () { return connect(state); },
                default: function () { return [state, []]; },
            });
        },
        CONNECTING: function () {
            return exports.Actions.match(action, {
                OPEN: function () { return [
                    exports.States.OPEN(__assign(__assign({}, state), { reconnectAttempt: 0 })),
                    [schedulePing(state)],
                ]; },
                CLOSE: function () { return [exports.States.CLOSED(state), clearAllTimeoutsEffects]; },
                default: function () { return [state, []]; },
            });
        },
        OPEN: function () {
            return exports.Actions.match(action, {
                PING_TIMEOUT: function () { return [
                    state,
                    [
                        exports.Effects.CLEAR_TIMEOUT({ key: "ping" }),
                        exports.Effects.SEND_PING(),
                        waitForPong(state),
                    ],
                ]; },
                PONG_TIMEOUT: function () { return [
                    state,
                    [
                        exports.Effects.TRIGGER_ACTION({ action: exports.Actions.CLOSE() }),
                        exports.Effects.TRIGGER_ACTION({ action: exports.Actions.RECONNECT() }),
                    ],
                ]; },
                HEARTBEAT: function () { return [
                    state,
                    [
                        exports.Effects.CLEAR_TIMEOUT({ key: "ping" }),
                        exports.Effects.CLEAR_TIMEOUT({ key: "pong" }),
                        schedulePing(state),
                    ],
                ]; },
                CLOSE: function () { return [exports.States.CLOSED(state), clearAllTimeoutsEffects]; },
                default: function () { return [state, []]; },
            });
        },
        CLOSED: function () {
            return exports.Actions.match(action, {
                RECONNECT: function () { return [
                    exports.States.RECONNECTING(__assign(__assign({}, state), { reconnectAttempt: state.reconnectAttempt + 1 })),
                    [scheduleConnect(state)],
                ]; },
                default: function () { return [state, []]; },
            });
        },
        RECONNECTING: function () {
            return exports.Actions.match(action, {
                CONNECT: function () { return connect(state); },
                default: function () { return [state, []]; },
            });
        },
    });
};
exports.update = update;
var wsMachine = function (config) {
    var ws;
    var wsState = atom_1.Atom.of(exports.States.INITIAL(__assign(__assign({}, config), { reconnectAttempt: 0, randSeed: Math.random() })));
    var timeouts = new Map();
    var wsHandlers = new Map();
    var addEventListener = function (webSocket, type, handler) {
        webSocket.addEventListener(type, handler);
        wsHandlers.set(type, handler);
    };
    var removeEventListeners = function (webSocket) {
        wsHandlers.forEach(function (h, k) {
            webSocket.removeEventListener(k, h);
        });
    };
    var nukeTimeout = function (k) {
        var t = timeouts.get(k);
        if (t) {
            clearTimeout(t);
        }
    };
    var clearTimeouts = function () {
        timeouts.forEach(function (v, k) {
            nukeTimeout(k);
        });
    };
    var transition = function (a) {
        var _a = exports.update(a, atom_1.deref(wsState)), newState = _a[0], effects = _a[1];
        atom_1.swap(wsState, function () { return newState; });
        handleEffects(effects);
    };
    var handleEffect = function (effect) {
        exports.Effects.match(effect, {
            CONNECT_WS: function (conn) {
                if (ws) {
                    removeEventListeners(ws);
                    clearTimeouts();
                    ws.close();
                }
                ws = new WebSocket(conn.url);
                var onOpen = function () { return transition(conn.onOpen); };
                addEventListener(ws, "open", onOpen);
                var onClose = function () {
                    transition(conn.onClose);
                    transition(exports.Actions.RECONNECT());
                };
                addEventListener(ws, "close", onClose);
                var onMessage = function (ev) {
                    var _a;
                    var msg = ev.data;
                    if ((_a = msg !== config.pongMsg) !== null && _a !== void 0 ? _a : "pong") {
                        config.onMessage(ev);
                    }
                    transition(conn.onPongMessage);
                };
                addEventListener(ws, "message", onMessage);
            },
            SCHEDULE_TIMEOUT: function (t) {
                timeouts.set(t.key, setTimeout(function () { return transition(t.onTimeout); }, t.timeoutMillis));
            },
            SEND_PING: function () {
                var _a;
                if (ws) {
                    ws.send((_a = config.pingMsg) !== null && _a !== void 0 ? _a : "ping");
                }
            },
            CLEAR_TIMEOUT: function (t) { return nukeTimeout(t.key); },
            TRIGGER_ACTION: function (a) { return transition(a.action); },
        });
    };
    var handleEffects = function (effects) {
        effects.forEach(function (e) {
            handleEffect(e);
        });
    };
    var send = function (data) {
        if (exports.States.is.OPEN(atom_1.deref(wsState)) && ws instanceof WebSocket) {
            ws.send(data);
        }
        else {
            var errorMsg = "Can't send message when websocket connection isn't in an open state. State is: " + atom_1.deref(wsState).tag;
            throw Error(errorMsg);
        }
    };
    if (config.onStateChange) {
        atom_1.addChangeHandler(wsState, "wsStateHandler", config.onStateChange);
    }
    return {
        connect: function () { return transition(exports.Actions.CONNECT()); },
        send: send,
        currentState: function () { return atom_1.deref(wsState); },
        disconnect: function () {
            atom_1.removeChangeHandler(wsState, "wsStateHandler");
            if (ws) {
                removeEventListeners(ws);
                clearTimeouts();
                atom_1.swap(wsState, function (currState) {
                    return exports.States.INITIAL(__assign(__assign({}, currState), { reconnectAttempt: 0 }));
                });
                ws.close();
            }
        },
    };
};
exports.wsMachine = wsMachine;
//# sourceMappingURL=index.js.map